import { RefreshCw, X } from 'lucide-react'
import { useRegisterSW } from 'virtual:pwa-register/react'

export default function SiteUpdateNotice() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      if (import.meta.env.DEV) console.error('Service worker registration failed', error)
    },
  })

  if (!needRefresh) return null

  return (
    <aside className="site-update" role="status" aria-live="polite">
      <RefreshCw aria-hidden="true" />
      <span>A newer version of the sanctuary website is available.</span>
      <button className="button button--gold" type="button" onClick={() => updateServiceWorker(true)}>Refresh</button>
      <button className="site-update__dismiss" type="button" onClick={() => setNeedRefresh(false)} aria-label="Dismiss update notice"><X /></button>
    </aside>
  )
}
